/** Prefer svh on mobile so iOS Safari bottom bar does not clip fixed/full-height panels. */
export const FULL_VIEWPORT_HEIGHT = "100svh";

export const fullViewportHeightProps = {
  h: FULL_VIEWPORT_HEIGHT,
  maxH: FULL_VIEWPORT_HEIGHT,
} as const;

/**
 * Dynamic viewport (dvh) sizes for modals - tracks mobile browser chrome show/hide.
 * Prefer these over vh for modal max-height / scroll regions.
 *
 * Mobile content cap leaves visible space above/below on small screens.
 */
export const MODAL_MOBILE_MAX_HEIGHT = "calc(100dvh - 80px)" as const;

export const MODAL_MAX_HEIGHT = {
  content: { base: MODAL_MOBILE_MAX_HEIGHT, md: "90dvh" },
  bodyDefault: { base: "70dvh", md: "calc(90dvh - 180px)" },
  bodyCompact: { base: "85dvh", md: "88dvh" },
  tallForm: { base: "85dvh", md: "90dvh" },
} as const;
